import React from 'react';
import classnames from 'classnames';
import GlobalProps from '../globalProps';

import './Line.css';

interface Props extends GlobalProps {
  equalWidth?: boolean;
  bottomSpacing?: boolean;
  align?: 'top' | 'bottom' | 'center';
  justify?: 'left' | 'right' | 'center';
}

export function Line({
  children,
  style,
  className,
  equalWidth,
  bottomSpacing,
  align = 'center',
  justify = 'left',
}: Props): JSX.Element {
  return (
    <div
      className={classnames(
        'line',
        className,
        {
          'line--equal-width': equalWidth,
          'line--bottom-spacing': bottomSpacing,
        },
        `line--align-${align}`,
        `line--justify-${justify}`
      )}
      style={style}
    >
      {children}
    </div>
  );
}
